// Configuration Firebase
// IMPORTANT: Remplacez ces valeurs par vos propres clés Firebase
export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Configuration Google GenAI (Backend Proxy)
export const genAIConfig = {
    models: {
        audit: "gemini-2.5-flash",
        fundamental: "gemini-2.5-flash",
    }
};

// Configuration Stripe
export const stripeConfig = {
    publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
    tiers: {
        free: {
            name: "Free",
            price: 0,
            features: [
                "50 trades maximum",
                "Métriques de base",
                "Courbe d'équité",
                "Calendrier de trading"
            ]
        },
        advanced: {
            name: "Advanced",
            price: 29,
            priceId: 'price_1So8R1IpV7ED4Y44ESzV2kZx',
            features: [
                "Trades illimités",
                "Toutes les métriques avancées",
                "5 audits IA par mois",
                "Analyses fondamentales",
                "Export PDF",
                "Accès au Strategy Hub"
            ]
        },
        professional: {
            name: "Professional",
            price: 79,
            priceId: 'price_1So8WsIpV7ED4Y44zfvl3Hdq',
            features: [
                "Tout du plan Advanced",
                "Audits IA illimités",
                "Analyses fondamentales illimitées",
                "Support prioritaire",
                "API Access",
                "Rapports personnalisés"
            ]
        }
    }
};

// Configuration de l'application
export const appConfig = {
    name: "StarQuant",
    version: "1.0.0",
    supportEmail: "support@starquant.ai",
    maxTradesPerPage: 20,
    maxAuditsPerMonth: {
        free: 0,
        advanced: 5,
        professional: -1 // illimité
    },
    maxFundamentalAnalysesPerMonth: {
        free: 0,
        advanced: 10,
        professional: -1 // illimité
    }
};
